import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=060be0bb&"
import script from "./Whatsapp.vue?vue&type=script&lang=js&"
export * from "./Whatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060be0bb')) {
      api.createRecord('060be0bb', component.options)
    } else {
      api.reload('060be0bb', component.options)
    }
    module.hot.accept("./Whatsapp.vue?vue&type=template&id=060be0bb&", function () {
      api.rerender('060be0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Whatsapp.vue"
export default component.exports